import { render } from "./CommentPage.vue?vue&type=template&id=44f51ede&scoped=true"
import script from "./CommentPage.vue?vue&type=script&lang=js"
export * from "./CommentPage.vue?vue&type=script&lang=js"

import "./CommentPage.vue?vue&type=style&index=0&id=44f51ede&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44f51ede"]])

export default __exports__